var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-template"},[_c('header-segment'),_vm._v(" "),_c('navigation-segment'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('footer-segment'),_vm._v(" "),_c('overlay-segment')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18756b94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/templates/MainTemplate.vue
// module id = null
// module chunks = 